module.exports = require('./isPeItemObject')
